import { Globals } from "../CoreApp/Globals";
import { EventToCanvas } from "./EventToCanvas";

export function handleGestureStart(event) {
  Globals._gestureActive = true;
  var x = event.clientX;
  var y = event.clientY;
  var canvas = document.getElementById("basecanvas");
  var rect = canvas.getBoundingClientRect();
  var p = EventToCanvas({ clientX: x, clientY: y }, rect.left, rect.top);

  Globals._gestureStartCoords = [p.x, p.y];
  event.preventDefault();
  event.stopPropagation();
}
